import { LexicalTextEditor } from "Components/LexicalTextEditor";
import React from "react";
import { Link } from "react-router-dom";

export default function PlutoConnect() {
  return (
    <main className="main">
      <h2 className="h5 font-semibold mb-4">Pluto Connect</h2>
      <div className="d-flex">
        <div className="d-flex flex-wrap flex-auto">
          <div className="flex-auto w-20 border-end border-grey-200">
            <ul className="list-unstyled connect-list-pluto d-flex flex-column row-gap-2">
              <li className="active">
                <Link className="d-flex flex-column align-items-center gap-1">
                  <div className="connect-icon w-11 h-11 rounded-lg d-flex justify-content-center align-items-center">
                    <i className="bx bx-home-alt-2 bx-sm"></i>
                  </div>
                  <span className="text-xs">Rooms</span>
                </Link>
              </li>
              <li>
                <Link className="d-flex flex-column align-items-center gap-1">
                  <div className="connect-icon w-11 h-11 rounded-lg d-flex justify-content-center align-items-center">
                    <i className="bx bx-message-square-dots bx-sm"></i>
                  </div>
                  <span className="text-xs">Index</span>
                </Link>
              </li>
              <li>
                <Link className="d-flex flex-column align-items-center gap-1">
                  <div className="connect-icon w-11 h-11 rounded-lg d-flex justify-content-center align-items-center">
                    <i className="bx bx-bell bx-sm"></i>
                  </div>
                  <span className="text-xs">Activity</span>
                </Link>
              </li>
              <li>
                <Link className="d-flex flex-column align-items-center gap-1">
                  <div className="connect-icon w-11 h-11 rounded-lg d-flex justify-content-center align-items-center">
                    <i className="bx bx-bell bx-sm"></i>
                  </div>
                  <span className="text-xs">Later</span>
                </Link>
              </li>
              <li>
                <Link className="d-flex flex-column align-items-center gap-1">
                  <div className="connect-icon w-11 h-11 rounded-lg d-flex justify-content-center align-items-center">
                    <i className="bx bx-dots-horizontal-rounded bx-sm"></i>
                  </div>
                  <span className="text-xs">More</span>
                </Link>
              </li>
            </ul>
          </div>
          <div className="flex-auto w-60 border-end border-grey-200 py-4">
            <div>
              <div className="px-4 d-flex justify-content-between align-items-center gap-3 mb-2">
                <h3 className="mb-0 text-md font-medium">Rooms</h3>
              </div>
              <div className="px-4">
                <ul className="sub-connect-list list-unstyled d-flex flex-column row-gap-1">
                  <li>
                    <Link className="d-flex align-items-center gap-2 px-2 py-2 rounded-md">
                      <i className="bx bx-hash"></i>
                      <span className="line-clamp-1">Pluto-implement</span>
                    </Link>
                  </li>
                  <li>
                    <Link className="d-flex align-items-center gap-2 px-2 py-2 rounded-md">
                      <i className="bx bx-hash"></i>
                      <span className="line-clamp-1">change-approval</span>
                    </Link>
                  </li>
                  <li>
                    <Link className="d-flex align-items-center gap-2 px-2 py-2 rounded-md">
                      <i className="bx bx-hash"></i>
                      <span className="line-clamp-1">culture-club</span>
                    </Link>
                  </li>
                  <li>
                    <Link className="d-flex align-items-center gap-2 px-2 py-2 rounded-md">
                      <i className="bx bx-hash"></i>
                      <span className="line-clamp-1">student success</span>
                    </Link>
                  </li>
                  <li className="active">
                    <Link className="d-flex align-items-center gap-2 px-2 py-2 rounded-md">
                      <i className="bx bx-lock-alt"></i>
                      <span className="line-clamp-1">approval-team</span>
                    </Link>
                  </li>
                </ul>
                <button
                  type="button"
                  className="px-2 py-2 w-100 d-flex align-items-center gap-1 rounded-md border-0 bg-transparent"
                >
                  <i className="bx bx-plus-circle"></i>
                  Add channels
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="w-100 d-flex flex-column">
          <div className="d-flex flex-column position-sticky top-0 z-10">
            <div className="px-4 pb-3 w-100 d-flex justify-content-between align-items-center border-bottom border-grey-200 bg-white">
              <div className="d-flex align-items-center">
                <div className="input-group">
                  <span
                    className="input-group-text border-transparent bg-white pe-0"
                    id="basic-addon1"
                  >
                    <i className="bx bx-lock-alt"></i>
                  </span>
                  <select
                    name=""
                    id=""
                    className="form-select border-transparent font-semibold ps-1"
                  >
                    <option value="">approval-team</option>
                  </select>
                </div>
              </div>
              <div className="d-flex align-items-center gap-3">
                <div className="d-flex align-items-center border rounded-md w-100">
                  <button className="px-2 py-2 border-0 bg-transparent border-end d-flex justify-content-center align-items-center text-grey-500">
                    <i className="bx bx-search text-xl"></i>
                  </button>
                  <button className="px-2 py-2 border-0 bg-transparent d-flex justify-content-center align-items-center text-grey-500">
                    <i className="bx bx-chevron-right text-xl"></i>
                  </button>
                </div>

                <div className="d-flex align-items-center border rounded-md w-100 px-2 py-1">
                  <div className="avatar-group d-flex align-items-center -space-x-3">
                    <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                      <img
                        src="../assets/images/avatars/8.jpg"
                        alt="Avatar 1"
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                      <img
                        src="../assets/images/avatars/6.jpg"
                        alt="Avatar 1"
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                      <img
                        src="../assets/images/avatars/5.jpg"
                        alt="Avatar 1"
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="avatar text-sm fw-bold text-gray-600 d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 rounded-full border border-2 border-white bg-grey-100">
                      8
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="px-4 py-2 w-100 d-flex justify-content-between align-items-center border-bottom border-grey-200 bg-grey-50">
              <div className="d-flex align-items-center">
                <div className="input-group input-group-sm bg-grey-100 rounded-md">
                  <span
                    className="input-group-text border-transparent bg-grey-100 pe-0"
                    id="basic-addon1"
                  >
                    <i className="bx bx-pin"></i>
                  </span>
                  <select
                    name=""
                    id=""
                    className="form-select border-transparent font-medium ps-1 text-grey-500 bg-grey-100"
                  >
                    <option value="">5 pinned</option>
                  </select>
                </div>

                <div>
                  <button
                    type="button"
                    className="d-inline-flex align-items-center gap-1 text-nowrap font-medium text-grey-700 border-transparent bg-transparent"
                  >
                    <i className="bx bx-plus-circle"></i> Add a bookmark
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="p-4 connect-post-msg">
            <ul className="connect-msg list-unstyled mb-4 d-flex flex-column row-gap-3 overflow-y-auto">
              <li>
                <div className="d-flex align-items-start">
                  <div className="w-10 h-10 me-2 flex-none rounded-lg overflow-hidden">
                    <img
                      src="../assets/images/avatars/8.jpg"
                      alt=""
                      className="w-100 h-100 object-fit-cover"
                    />
                  </div>
                  <div className="d-flex flex-column">
                    <div>
                      <span className="font-semibold me-2">Dann Parker</span>{" "}
                      <span className="text-xs font-medium text-slate-400">
                        4:37pm
                      </span>
                    </div>
                    <p>
                      Hardeep, can you share the specific shades they had in
                      mind? Meanwhile, @Tasha Smith, the font you used in the
                      last mockup was spot on! Can we reuse?
                    </p>
                  </div>
                </div>
              </li>
              <li>
                <div className="d-flex align-items-start">
                  <div className="w-10 h-10 me-2 flex-none rounded-lg overflow-hidden">
                    <img
                      src="../assets/images/avatars/8.jpg"
                      alt=""
                      className="w-100 h-100 object-fit-cover"
                    />
                  </div>
                  <div className="d-flex flex-column">
                    <div>
                      <span className="font-semibold me-2">Mia Alvarez</span>{" "}
                      <span className="text-xs font-medium text-slate-400">
                        4:42 pm
                      </span>
                    </div>
                    <p>
                      Morning! 👋 I just got feedback from marketing. They'd
                      like to see some pop of color in the call-to-action
                      buttons. <a href="#">@Lena Olsson</a> , would you like to
                      take this up?
                    </p>
                  </div>
                </div>
              </li>
              <li className="py-3">
                <div className="time-divider position-relative text-center">
                  <span className="ps-3 pe-2 py-1 text-xs font-medium text-grey-500 rounded-pill border border-grey-200 bg-white position-relative z-1">
                    Yesterday <i className="bx bx-chevron-down"></i>
                  </span>
                </div>
              </li>
              <li>
                <div className="d-flex align-items-start">
                  <div className="w-10 h-10 me-2 flex-none rounded-lg overflow-hidden">
                    <img
                      src="../assets/images/avatars/8.jpg"
                      alt=""
                      className="w-100 h-100 object-fit-cover"
                    />
                  </div>
                  <div className="d-flex flex-column">
                    <div>
                      <span className="font-semibold me-2">Gabriella Kim</span>{" "}
                      <span className="text-xs font-medium text-slate-400">
                        2:37pm
                      </span>
                    </div>
                    <p>
                      Team! Reminder about our brainstorm at 3 PM. Looking
                      forward to some fresh ideas!
                    </p>

                    <div className="max-w-400 d-flex align-items-center gap-2 border rounded-md w-100 px-2 py-1 mt-2">
                      <div className="avatar-group d-flex align-items-center -space-x-3">
                        <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                          <img
                            src="../assets/images/avatars/8.jpg"
                            alt="Avatar 1"
                            className="w-full h-full object-cover"
                          />
                        </div>
                        <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                          <img
                            src="../assets/images/avatars/6.jpg"
                            alt="Avatar 1"
                            className="w-full h-full object-cover"
                          />
                        </div>
                        <div className="avatar rounded-full border-2 border-white bg-primary d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 overflow-hidden border border-2 border-white bg-grey-100">
                          <img
                            src="../assets/images/avatars/5.jpg"
                            alt="Avatar 1"
                            className="w-full h-full object-cover"
                          />
                        </div>
                        <div className="avatar text-sm fw-bold text-gray-600 d-flex justify-content-center align-items-center flex-shrink-0 flex-grow-0 w-8 h-8 rounded-full border border-2 border-white bg-grey-100">
                          4
                        </div>
                      </div>
                      <div className="d-flex align-items-center gap-3">
                        <span className="text-primary-500 font-medium">
                          4 replies{" "}
                        </span>
                        <Link className="text-grey-500 font-medium text-decoration-none">
                          View thread
                        </Link>
                      </div>
                      <Link className="ms-auto d-flex align-items-center text-decoration-none text-grey-400">
                        <i className="bx bx-chevron-right bx-sm"></i>
                      </Link>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <div className="d-flex align-items-start">
                  <div className="w-10 h-10 me-2 flex-none rounded-lg overflow-hidden">
                    <img
                      src="../assets/images/avatars/8.jpg"
                      alt=""
                      className="w-100 h-100 object-fit-cover"
                    />
                  </div>
                  <div className="d-flex flex-column">
                    <div>
                      <span className="font-semibold me-2">Gabriella Kim</span>{" "}
                      <span className="text-xs font-medium text-slate-400">
                        2:40pm
                      </span>
                    </div>
                    <p>
                      Team! Reminder about our brainstorm at 3 PM. Looking
                      forward to some fresh ideas!
                    </p>
                  </div>
                </div>
              </li>
              <li>
                <div className="d-flex align-items-start">
                  <div className="w-10 h-10 me-2 flex-none rounded-lg overflow-hidden">
                    <img
                      src="../assets/images/avatars/5.jpg"
                      alt=""
                      className="w-100 h-100 object-fit-cover"
                    />
                  </div>
                  <div className="d-flex flex-column">
                    <div>
                      <span className="font-semibold me-2">Isaac Goldberg</span>{" "}
                      <span className="text-xs font-medium text-slate-400">
                        2:45 pm
                      </span>
                    </div>
                    <p>
                      Quick question: Who was behind the tablet designs? Need to
                      discuss a small tweak.
                    </p>
                  </div>
                </div>
              </li>
              <li>
                <div className="d-flex align-items-start">
                  <div className="w-10 h-10 me-2 flex-none rounded-lg overflow-hidden">
                    <img
                      src="../assets/images/avatars/5.jpg"
                      alt=""
                      className="w-100 h-100 object-fit-cover"
                    />
                  </div>
                  <div className="d-flex flex-column">
                    <div>
                      <span className="font-semibold me-2">Isaac Goldberg</span>{" "}
                      <span className="text-xs font-medium text-slate-400">
                        4:37pm
                      </span>
                    </div>
                    <p>
                      <strong>Quick question:</strong> Who was behind the tablet
                      designs? Need to discuss a small tweak.
                    </p>
                  </div>
                </div>
              </li>
              <li>
                <div className="d-flex align-items-start">
                  <div className="w-10 h-10 me-2 flex-none rounded-lg overflow-hidden">
                    <img
                      src="../assets/images/avatars/5.jpg"
                      alt=""
                      className="w-100 h-100 object-fit-cover"
                    />
                  </div>
                  <div className="d-flex flex-column">
                    <div>
                      <span className="font-semibold me-2">Isaac Goldberg</span>{" "}
                      <span className="text-xs font-medium text-slate-400">
                        5:45 pm
                      </span>
                    </div>
                    <p>
                      Quick question: Who was behind the tablet designs? Need to
                      discuss a small tweak.
                    </p>
                  </div>
                </div>
              </li>

              <li className="py-3">
                <div className="time-divider position-relative text-center">
                  <span className="ps-3 pe-2 py-1 text-xs font-medium text-grey-500 rounded-pill border border-grey-200 bg-white position-relative z-1">
                    Today <i className="bx bx-chevron-down"></i>
                  </span>
                </div>
              </li>
              <li>
                <div className="d-flex align-items-start">
                  <div className="w-10 h-10 me-2 flex-none rounded-lg overflow-hidden">
                    <img
                      src="../assets/images/avatars/12.jpg"
                      alt=""
                      className="w-100 h-100 object-fit-cover"
                    />
                  </div>
                  <div className="d-flex flex-column">
                    <div>
                      <span className="font-semibold me-2">Dann Cox</span>{" "}
                      <span className="text-xs font-medium text-slate-400">
                        10 min ago
                      </span>
                    </div>
                    <p>
                      Team! Reminder about our brainstorm at 3 PM. Looking
                      forward to some fresh ideas!
                    </p>

                    <ul className="list-unstyled d-inline-flex gap-2 mt-2">
                      <li>
                        <span className="px-2 py-0-5 d-inline-flex align-items-center gap-1 text-xs font-medium rounded text-red-500 bg-red-100">
                          <i className="bx bx-message-alt-error text-base"></i>{" "}
                          Urgent
                        </span>
                      </li>
                      <li>
                        <span className="px-2 py-0-5 d-inline-flex align-items-center gap-1 text-xs font-medium rounded text-grey-500 bg-grey-100">
                          <img
                            src="../assets/images/icons/date-time-calendar.svg"
                            alt=""
                          />{" "}
                          Response required in <strong>2 hours, 13 mins</strong>
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
              <li>
                <div className="d-flex align-items-start">
                  <div className="w-10 h-10 me-2 flex-none rounded-lg overflow-hidden">
                    <img
                      src="../assets/images/avatars/12.jpg"
                      alt=""
                      className="w-100 h-100 object-fit-cover"
                    />
                  </div>
                  <div className="d-flex flex-column">
                    <div>
                      <span className="font-semibold me-2">Dann Cox</span>{" "}
                      <span className="text-xs font-medium text-slate-400">
                        Now
                      </span>
                    </div>
                    <p>
                      Does anyone know how to recover the "Foundations" project
                      in Figma? 🙈
                    </p>
                  </div>
                </div>
              </li>
            </ul>
            <div>
              <LexicalTextEditor />
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
